<template>
  <div class="content">
    <div>
      <div v-if="!onEdit">
        <div
          class="fs-24 font-weight-bold d-flex flex-column align-items-start"
        ></div>
      </div>
      <div v-else class="mt-3 mb-3">
        <EditForm
          type="edit"
          :vehicleData="info"
          @onCancel="() => (this.onEdit = false)"
          @changeData="changeData"
        />
      </div>
      <div v-if="!onEdit">
        <div class="fs-20 font-weight-bold mt-15 top-description">
          {{ info.rego ? `[${info.rego}]` : '' }} Please fill out your car information
        </div>
        <b-card class="pb-4 rounded-2 shadow-sm mb-4">
          <div class="center">
            <SectionTitle sectionTitle="CAR INFORMATION"></SectionTitle>
            <b-row>
              <b-col cols="12" md="6" class="px-2">
                <custom-select
                  label="State"
                  v-model="info.location"
                  :options="states"
                  :error="$v.info.location.$error"
                  helperText="Please select state"
                  name="state"
                  :isFocus="curStepInput === 1"
                  :isLeftAlign=true
                  @setNextInput="setNextInputNumber"
                />
              </b-col>
              <b-col cols="12" md="6" class="px-2">
                <custom-autocomplete-input
                  label="Make"
                  v-model="info.make"
                  :options="makes"
                  :error="$v.info.make.$error"
                  helperText="Please enter make"
                  name="make"
                  :isFocus="curStepInput === 2"
                  :isLoadAble="true"
                  @setNextInput="setNextInputNumber"
                  placeholder="Enter make"
                  :clearable=true
                />
              </b-col>
              <b-col cols="12" md="6" class="px-2">
                <custom-clear-select
                  id="model"
                  label="Model"
                  v-model="info.model"
                  :isClear="info.model !== '' && models.length > 1"
                  :options="models"
                  :error="$v.info.model.$error"
                  helperText="Please select model"
                  name="model"
                  :isFocus="curStepInput === 3"
                  :isLoadAble="true"
                  :helperTooltip="modelHelperTooltip"
                  @setNextInput="setNextInputNumber"
                />
              </b-col>
              <b-col cols="12" md="6" class="px-2">
                <custom-select
                  label="Colour"
                  v-model="info.color"
                  :options="colors"
                  :error="$v.info.color.$error"
                  helperText="Please select colour"
                  name="color"
                  :isFocus="curStepInput === 4"
                  :isLeftAlign=true
                  @setNextInput="setNextInputNumber"
                />
              </b-col>
              <b-col v-if="info.color === 'OTHER'" class="custom-width px-2" cols="2">
              </b-col>
              <b-col v-if="info.color === 'OTHER'" :class="[isMobile ? 'col-md-6 col-12' : 'specify-color col-10', 'px-2']">
                <float-label label="Specify colour">
                  <b-input
                    v-model.trim="info.specifyColor"
                    @blur="trimColorOnBlur"
                    ref="specifyColorInput"
                    placeholder="Enter colour"
                    maxlength="15"
                    :class="[
                      specifyColorValidate ? 'invalid' : '',
                      'shadow-none',
                    ]"
                  />
                </float-label>
                <div class="fs-12 text-right mb-2 mt-n3 pr-2 err-text">
                  {{ specifyColorValidate }}
                </div>
              </b-col>
              <b-col cols="12" md="6" class="px-2">
                <custom-clear-select
                  id="year"
                  label="Year"
                  v-model="info.year"
                  :isClear="info.year !== ''"
                  :options="years"
                  helperText="Please select year"
                  :error="$v.info.year.$error"
                  name="year"
                  :isFocus="curStepInput === 5"
                  :isLoadAble="true"
                  @setNextInput="setNextInputNumber"
                />
              </b-col>
              <b-col cols="12" md="6" class="px-2">
                <custom-clear-select
                  id="variant"
                  label="Variant"
                  name="badgeEdition"
                  v-model="info.badgeEdition"
                  :options="badgeEditions"
                  :isFocus="curStepInput === 10"
                  :isLoadAble="true"
                  :isClear="this.isClearOptions.isClearBadgeEdition"
                  :error="$v.info.badgeEdition.$error"
                  helperText="Please select variant"
                  @setNextInput="setNextInputNumber"
                />
              </b-col>
              <b-col cols="12" md="6" class="px-2">
                <custom-clear-select
                  id="body-type"
                  label="Body type"
                  name="bodyType"
                  v-model="info.bodyType"
                  :options="bodyTypes"
                  :isFocus="curStepInput === 6"
                  :isClear="this.isClearOptions.isClearBody"
                  :error="$v.info.bodyType.$error"
                  helperText="Please select body type"
                  @setNextInput="setNextInputNumber"
                />
              </b-col>
              <b-col cols="6" class="px-2">
                <custom-clear-select
                  id="fuel-type"
                  label="Fuel type"
                  name="fuelType"
                  v-model="info.fuelType"
                  :options="fuelTypes"
                  :isFocus="curStepInput === 7"
                  :isClear="this.isClearOptions.isClearFuel"
                  :error="$v.info.fuelType.$error"
                  helperText="Please select fuel type"
                  @setNextInput="setNextInputNumber"
                />
              </b-col>
              <b-col cols="6" class="px-2">
                <custom-clear-select
                  id="drive"
                  label="Drive type"
                  name="drive"
                  v-model="info.drive"
                  :options="drives"
                  :error="$v.info.drive.$error"
                  :isClear="this.isClearOptions.isClearDrive"
                  helperText="Please select drive type"
                  :isFocus="curStepInput === 8"
                  @setNextInput="setNextInputNumber"
                />
              </b-col>
              <b-col cols="12" md="6" class="px-2">
                <custom-clear-select
                  id="transmission"
                  label="Transmission"
                  name="transmission"
                  :options="transmissions"
                  v-model="info.transmission"
                  :error="$v.info.transmission.$error"
                  :isClear="this.isClearOptions.isClearTrans"
                  helperText="Please select transmission"
                  :isFocus="curStepInput === 9"
                  @setNextInput="setNextInputNumber"
                />
              </b-col>
              <b-col cols="6" class="px-2">
                <custom-clear-select
                  id="series"
                  label="Series"
                  v-model="info.series"
                  :options="series"
                  :isFocus="curStepInput === 11"
                  :error="$v.info.series.$error"
                  :isClear="this.isClearOptions.isClearSeries"
                  helperText="Please select series"
                  @setNextInput="setNextInputNumber"
                />
              </b-col>
              <b-col cols="6" class="px-2">
                <custom-select
                  label="Model year"
                  v-model="info.model_year"
                  :options="modelYears"
                  :isFocus="curStepInput === 12"
                  :error="$v.info.model_year.$error"
                  helperText="Please select model year"
                  :isLeftAlign=true
                  @setNextInput="setNextInputNumber"
                />
              </b-col>
              <b-col cols="12" md="6" class="px-2">
                <custom-clear-select
                  id="engine-type"
                  label="Engine type"
                  v-model="info.engineType"
                  :options="engineTypes"
                  :isFocus="curStepInput === 13"
                  :error="$v.info.engineType.$error"
                  :isClear="this.isClearOptions.isClearEngine"
                  :mapper="redbookDataMapper"
                  helperText="Please select engine type"
                  @setNextInput="setNextInputNumber"
                />
              </b-col>
            </b-row>
          </div>
          <div class="center">
            <SectionTitle sectionTitle="CONDITION"></SectionTitle>
            <b-row>
              <b-col class="mt-3">
                <float-label
                  v-b-modal.modal-exterior
                  class="font-weight-bold fw-400 pb-2"
                  label="Exterior condition"
                ></float-label>
                <div style="max-width: 350px">
                  <b-form-rating
                    v-model="info.exterior"
                    :class="[
                      exteriorValidate ? 'bi-star-error' : '',
                      isMobile ? 'ml-1' : 'ml-4',
                      'mb-2 border-0 w-15 px-0 mt-n3 form-stars',
                    ]"
                    size="lg"
                  />
                  <div
                    class="mx-auto font-weight-regular mb-4"
                    v-if="info.exterior"
                  >
                    <p class="text-center fs-14 rate-label mb-1">
                      {{ exteriorRate[info.exterior - 1].text }}
                    </p>
                    <p class="fs-12 text-center mb-1">{{ exteriorRate[info.exterior - 1].desc }}</p>
                  </div>
                </div>
                <div class="fs-12 text-left mb-2 mt-n3 pl-2 err-text">
                  {{ exteriorValidate }}
                </div>
              </b-col>
              <b-col md="6" class="mt-3 mb-3">
                <float-label
                  v-b-modal.modal-interior
                  class="font-weight-bold fw-400 pb-2"
                  label="Interior condition"
                ></float-label>
                <div style="max-width: 350px">
                  <b-form-rating
                    v-model="info.interior"
                    :class="[
                      interiorValidate ? 'bi-star-error' : '',
                      isMobile ? 'ml-1' : 'ml-4',
                      'mb-2 border-0 w-15 px-0 mt-n3 form-stars',
                    ]"
                    size="lg"
                  />
                  <div
                    class="mx-auto font-weight-regular mb-4"
                    v-if="info.interior"
                  >
                    <p class="text-center fs-14 rate-label mb-1">
                      {{ interiorRate[info.interior - 1].text }}
                    </p>
                    <p class="fs-12 text-center mb-1">{{ interiorRate[info.interior - 1].desc }}</p>
                  </div>
                </div>
                <div class="fs-12 text-left mb-2 mt-n3 pl-2 err-text">
                  {{ interiorValidate }}
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6" class="px-2">
                <float-label label="Odometer">
                  <b-input
                    v-model="info.kms"
                    ref="kmsInput"
                    placeholder="Enter kms"
                    pattern="\d*"
                    :class="[
                      kmsValidate ? 'invalid' : '',
                      curStepInput === 14 ? 'next-input' : '',
                      'shadow-none',
                    ]"
                    @blur="setNextInputNumber"
                    @keypress="isNumber"
                    @keyup="removeFirstZero"
                  />
                </float-label>
                <div class="fs-12 text-left mb-2 mt-n3 pr-2 err-text">
                  {{ kmsValidate }}
                </div>
              </b-col>
              <b-col cols="6" class="px-2">
                <custom-select
                  label="Owner's manual"
                  v-model="info.ownerManual"
                  :options="ownerManualOptions"
                  :error="$v.info.ownerManual.$error"
                  helperText="Please select your owner's manual"
                  name="ownerManual"
                  :isFocus="curStepInput === 16"
                  :isLeftAlign=true
                />
              </b-col>
              </b-row>
            <b-row>
              <b-col cols="12" md="6" class="px-2">
                <custom-select
                  label="Service history"
                  v-model="info.serviceHistory"
                  :options="serviceHistories"
                  :error="$v.info.serviceHistory.$error"
                  helperText="Please select your service history"
                  name="serviceHistory"
                  :ask="true"
                  :tooltip="serviceHistoryTooltip"
                  :isFocus="curStepInput === 17"
                  :isLeftAlign=true
                />
              </b-col>
              <b-col cols="12" md="6" class="px-2">
                <custom-select
                  label="Servicing provider"
                  v-model="info.serviceHistoryDetail"
                  :options="serviceHistoryDetails"
                  :error="$v.info.serviceHistoryDetail.$error"
                  helperText="Please select your servicing provider"
                  name="serviceHistoryDetail"
                  :selectDisabled="info.serviceHistory === '' || info.serviceHistory === 'None'"
                  :isFocus="curStepInput === 19"
                  :isLeftAlign=true
                />
              </b-col>
              <b-col cols="12" md="6" class="px-2">
                <custom-select
                  label="Number of keys"
                  v-model="info.key"
                  :options="keys"
                  :error="$v.info.key.$error"
                  helperText="Please select how many keys"
                  name="key"
                  :isFocus="curStepInput === 15"
                  @setNextInput="setNextInputNumber"
                  :isLeftAlign=true
                />
              </b-col>
              <b-col cols="12" md="6" class="px-2">
                <custom-select
                  label="Tyres needing replacement"
                  v-model="info.tyreReplacement"
                  :options="tyreReplacements"
                  name="tyreReplacement"
                  :optional="true"
                  :isFocus="curStepInput === 18"
                  :isLeftAlign=true
                />
              </b-col>
            </b-row>
            <b-row class="mt-4">
              <b-col class="px-2">
                <custom-text-area
                  label="Car description - Damages and extras"
                  v-model="info.description"
                  :rows="isMobile ? '8' : '5'"
                  :error="$v.info.description.$error || this.info.description.length >= 2000"
                  name="carDescription"
                  @focus="validateDescription($event)"
                  @input="validateLength($event)"
                  @keyup="validateMaxlength($event)"
                  :isCarDescription="true"
                  :helperText="carDescriptionValidate"
                />
                <!-- <div :show="this.isShowErr === true" class="col-md-6 col-12 fs-12 text-right mb-2 mt-n3 pr-2 err-text">
                  {{ carDescriptionValidate }}
                </div> -->
              </b-col>
            </b-row>
          </div>
          <div class="center" style="margin-bottom: 1.75rem;">
            <SectionTitle sectionTitle="ADDITIONAL"></SectionTitle>
            <b-row>
              <b-col cols="12" md="6">
                <custom-toggle
                  v-model="info.outstandingFinance"
                  label="Do you have outstanding finance on this car?"
                  :error="$v.info.outstandingFinance.$error"
                />
              </b-col>
              <b-col cols="12" md="6">
                <custom-toggle
                  v-model="info.majorAccident"
                  label="Has this car been in a prior major accident?"
                  :error="$v.info.majorAccident.$error"
                />
              </b-col>
              <b-col cols="12" md="6">
                <custom-toggle
                  v-model="info.hailOrFlooding"
                  label="Has this car been damaged by a hailstorm/flooding?"
                  :error="$v.info.hailOrFlooding.$error"
                />
              </b-col>
              <b-col cols="12" md="6">
                <custom-toggle
                  v-model="info.warningLights"
                  label="Any warning lights/mechanical issues?"
                  :error="$v.info.warningLights.$error"
                />
              </b-col>
            </b-row>
          </div>
          <div :style="isMobile ? 'height: 20px;' : 'height: 40px'"></div>
          <btn-group
            @onOk="next"
            @onCancel="() => {}"
            back="top-page"
            :okBtnDisable="!isValid ? false : isValid"
          />
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  FETCH_DETAIL,
  SET_INFO,
  FETCH_INIT,
  FETCH_MODELS,
  FETCH_YEARS,
  FETCH_BADGES,
  CLEAR_INFO_EXTEND,
  SET_PREV_LENGTH,
  CLEAR_SERVICE_HISTORY_DETAIL,
  SET_INPUT_VALID,
  SET_OTHER_OPTIONS,
  SET_RB_LOOKUP_FINISH,
  CLEAR_RELEVANT_RBDESC,
  SET_COLOR,
  INIT_CAR_DETAILS,
} from "@/store/info/actions";
import regex, { formatNumberWithComma } from "../../helper/utils";
import mixin from "@/mixins/common";
import { required } from "vuelidate/lib/validators";
// import { modelYearRange } from "../../helper/constant";
import customerDetailService from "@/services/customer-detail";
import { EXTERIOR_RATE, INTERIOR_RATE } from "@/config/constants";
import { blankOptionList } from "@/helper/constant";

export default {
  name: "Index",
  mixins: [mixin],
  components: {
    CustomSelect: () => import("../../components/common/CustomSelect"),
    CustomClearSelect: () => import("../../components/common/CustomClearSelect"),
    EditForm: () => import("../../components/vehicle/Form"),
    BtnGroup: () => import("../../components/common/BtnGroup.vue"),
    FloatLabel: () => import("../../components/common/FloatLabel.vue"),
    SectionTitle: () => import("../../components/vehicle/SectionTitle.vue"),
    CustomAutocompleteInput: () =>
      import("../../components/common/CustomAutocompleteInput.vue"),
    CustomTextArea: () => import("../../components/common/CustomTextArea.vue"),
    CustomToggle: () => import("../../components/common/CustomToggle.vue"),
  },
  data() {
    return {
      val1: 1,
      val2: 2,
      val3: 3,
      val4: 4,
      val5: 5,
      onEdit: false,
      submitted: false,
      submittedDesc: false,
      isShowErr: false,
      exteriorRate: [...EXTERIOR_RATE],
      interiorRate: [...INTERIOR_RATE],
      curStepInput: 1,
      inputStep: [
        {
          step: 1,
          key: "location",
        },
        {
          step: 2,
          key: "make",
        },
        {
          step: 3,
          key: "model",
        },
        {
          step: 4,
          key: "color",
        },
        {
          step: 5,
          key: "year",
        },
        {
          step: 6,
          key: "badgeEdition",
        },
        {
          step: 7,
          key: "bodyType",
        },
        {
          step: 8,
          key: "fuelType",
        },
        {
          step: 9,
          key: "drive",
        },
        {
          step: 10,
          key: "transmission",
        },
        {
          step: 11,
          key: "series",
        },
        {
          step: 12,
          key: "model_year",
        },
        {
          step: 13,
          key: "engineType",
        },
        {
          step: 14,
          key: "kms",
        },
        {
          step: 15,
          key: "key",
        },
        {
          step: 16,
          key: "ownerManual",
        },
        {
          step: 17,
          key: "serviceHistory",
        },
        {
          step: 18,
          key: "exterior",
        },
        {
          step: 19,
          key: "interior",
        },
        {
          step: 20,
          key: "",
        },
      ],
      beforeUpdateBadges: this.$store.getters.badges,
      isMobile: true,
      redbookDataMapper: null,
      tyreReplacements: [
        "No replacement",
        "One tyre",
        "Two tyres",
        "Three tyres",
        "Four tyres",
      ],
      serviceHistoryDetails: [
        "Manufacturer/franchise dealer only",
        "Independent mechanic only",
        "Mixed",
      ],
      serviceHistoryTooltip: {
        Full:
          " - You must have evidence of complete and accurate records of service history from purchase until date. It must be stamped or invoiced by a franchise dealer or independent service agent.",
        Partial:
          " - Some records of service history are missing. You must have evidence of the records you have.",
      },
      rbLookupFinish: this.$store.getters.rbLookupFinish,
      regoSearch: this.$store.getters.regoSearch,
    };
  },
  computed: {
    ...mapState({
      info: (state) => state.info.curVehicleInfo,
      makes: (state) => state.info.makes,
      models: (state) => state.info.models,
      years: (state) => state.info.years,
      colors: (state) => state.info.colors,
      badges: (state) => state.info.badges,
      editions: (state) => state.info.editions,
      drives: (state) => state.info.drives,
      transmissions: (state) => state.info.transmissions,
      shifts: (state) => state.info.shifts,
      steps: (state) => state.common.steps,
      fuelTypes: (state) => state.info.fuelTypes,
      bodyTypes: (state) => state.info.bodyTypes,
      series: (state) => state.info.series,
      engineTypes: (state) => state.info.engineTypes,
      badgeEditions: (state) => state.info.badgeEditions,
      isClearOptions: (state) => state.info.isClearOptions,
      modelYears: (state) => state.info.modelYears,
      isInputValid: (state) => state.info.isInputValid,
    }),
    // modelYears: function () {
    //   const temp = modelYearRange();
    //   return ["Not sure", ...temp];
    // },
    states: function () {
      return ["ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"];
    },
    isValid: function () {
      if (this.isInputValid === true) {
        return (
          this.info.make &&
          this.info.model &&
          this.info.year &&
          this.info.color &&
          (this.info.color === "OTHER" ? this.info.specifyColor.length > 0 : true) &&
          this.info.location &&
          this.info.kms &&
          this.info.ownerManual &&
          this.info.serviceHistory &&
          this.info.outstandingFinance &&
          this.info.majorAccident &&
          this.info.hailOrFlooding &&
          this.info.warningLights &&
          (this.info.serviceHistory === 'None' || this.info.serviceHistoryDetail !== '') &&
          (this.drives.length <= 1 || this.info.drive !== "") &&
          (this.transmissions.length <= 1 || this.info.transmission !== "") &&
          this.info.exterior &&
          this.info.interior &&
          this.info.key &&
          (this.badgeEditions.length <= 1 || this.info.badgeEdition !== "") &&
          (this.fuelTypes.length <= 1 || this.info.fuelType !== "") &&
          (this.series.length <= 1 || this.info.series !== "") &&
          (this.modelYears.length <= 1 || this.info.model_year !== "") &&
          (this.engineTypes.length <= 1 || this.info.engineType !== "") &&
          (this.bodyTypes.length <= 1 || this.info.bodyType !== "") &&
          !this.$v.info.make.$error &&
          !this.$v.info.model.$error &&
          !this.$v.info.year.$error &&
          !this.$v.info.color.$error &&
          !this.$v.info.specifyColor.$error &&
          !this.$v.info.location.$error &&
          !this.$v.info.kms.$error &&
          !this.$v.info.ownerManual.$error &&
          !this.$v.info.serviceHistory.$error &&
          !this.$v.info.serviceHistoryDetail.$error &&
          !this.$v.info.drive.$error &&
          !this.$v.info.transmission.$error &&
          !this.$v.info.exterior.$error &&
          !this.$v.info.interior.$error &&
          !this.$v.info.key.$error &&
          !this.$v.info.badgeEdition.$error &&
          !this.$v.info.fuelType.$error &&
          !this.$v.info.series.$error &&
          !this.$v.info.model_year.$error &&
          !this.$v.info.engineType.$error &&
          !this.$v.info.bodyType.$error &&
          !this.$v.info.outstandingFinance.$error &&
          !this.$v.info.majorAccident.$error &&
          !this.$v.info.hailOrFlooding.$error &&
          !this.$v.info.warningLights.$error
        );
      }
      return false;
    },
    kmsValidate: function () {
      if (this.submitted && !this.info.kms) return "Please enter kms";
      //eslint-disable-next-line
      if (this.submitted && regex("^-?[d,]+$", this.info.kms))
        return "Please enter only numerics";
      return "";
    },
    exteriorValidate: function () {
      if (this.submitted && this.info.exterior === null)
        return "Please select exterior condition";
      return "";
    },
    interiorValidate: function () {
      if (this.submitted && this.info.interior === null)
        return "Please select interior condition";
      return "";
    },
    carDescriptionValidate: function () {
      if (this.submittedDesc && this.info.description.length < 1)
        return "Please enter car description";
      if (this.info.description.length >= 2000) 
        return "Please enter less than 2,000 characters";
      return "";
    },
    badgeRequestValue: function () {
      return !blankOptionList.includes(this.info.badge) ? this.info.badge : "";
    },
    keys: function () {
      return ["1", "2", "3 or more"];
    },
    serviceHistories: function () {
      return ["Full", "Partial", "None"];
    },
    ownerManualOptions: function () {
      return ["Yes", "No"];
    },
    mobileMediaQuery: function() {
      return window.matchMedia("(min-width: 768px)");
    },
    specifyColorValidate: function() {
      if (this.submitted &&  this.info.color === 'OTHER' && !this.info.specifyColor) return "Please enter specify colour";
      return "";
    },
    modelHelperTooltip: function() {
      return {
        label: "I can't find my model",
        content: "Select 'Other' and add your car model details in the 'Car description' field."
      }
    },
  },
  methods: {
    validateMaxlength: function (value) {
      this.$v.info.description.$reset();
      if (value.length >= 1 && value.length < 2000) {
        this.$store.dispatch(SET_INPUT_VALID, true);
      } else {
        this.$store.dispatch(SET_INPUT_VALID, false);
      }
      if (value.length > 2000) {
        this.info.description = value;
        this.$v.info.description.$touch();
      }
    },
    validateDescription: function (value) {
      this.isShowErr = value;
    },
    validateLength: function (value) {
      this.isShowErr = value;
      this.submittedDesc = false;
    },
    next: function () {
      this.submitted = true;
      this.submittedDesc = true;
      this.$v.info.$touch();
      if (this.isValid) {
        this.$store.dispatch(SET_INFO, {
          ...this.info,
        });
        if (!this.info.recordId) {
          this.$store.dispatch(INIT_CAR_DETAILS, {
            ...this.info,
            reservePrice: this.info.reservePrice || 0,
          });
        }
        this.$store.dispatch("setProgress", 48);
        this.$store.dispatch(SET_RB_LOOKUP_FINISH, true);
        this.$router.push({ name: "photo-upload", query: this.$route.query });
      }
    },
    getData: function () {
      if (this.rbLookupFinish === false) {
        this.$store.dispatch(FETCH_INIT, {
          model: this.info.model,
          make: this.info.make,
          year: this.info.year,
          badge: this.info.badge,
        });
      }
    },
    changeData: function () {
      this.info.badge = "";
    },
    setNextInputNumber() {
      for (const item of this.inputStep) {
        if (!this.info[item.key] || item.key === "") {
          this.curStepInput = item.step;
          break;
        }
      }
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode >= 48 &&
        charCode <= 57 &&
        !(charCode === 48 && this.info.kms === "")
      ) {
        return true;
      } else {
        evt.preventDefault();
        return false;
      }
    },
    removeFirstZero() {
      if (/^0/.test(this.info.kms)) {
        this.info.kms = this.info.kms.replace(/^0+/, "");
      }
    },
    fetchDetailRequestValues(name, val) {
      const allRequestValues = {
        ...(this.info.make ? { make: this.info.make } : {}),
        ...(this.info.model && this.info.model !== "Other" ? { model: this.info.model } : {}),
        ...(this.info.year ? { year: this.info.year } : {}),
        ...(this.info.badge && !blankOptionList.includes(this.info.badge)
          ? { badge: this.info.badge }
          : {}),
        ...(this.info.edition && !blankOptionList.includes(this.info.edition)
          ? { edition: this.info.edition }
          : {}),
        ...(this.info.bodyType ? { bodyType: this.info.bodyType } : {}),
        ...(this.info.fuelType ? { fuelType: this.info.fuelType } : {}),
        ...(this.info.transmission
          ? { transmission: this.info.transmission }
          : {}),
        ...(this.info.series && !blankOptionList.includes(this.info.series)
          ? { series: this.info.series }
          : {}),
        ...(this.info.engineType && this.info.engineType !== "Not sure"
          ? { engineType: this.info.engineType }
          : {}),
        ...(this.info.drive ? { drive: this.info.drive } : {}),
      };
      return {
        ...allRequestValues,
        [name]: val && val !== "Not sure" ? val : "",
      };
    },
    getRedbookDataMapper() {
      customerDetailService
        .getRedbookDataMapper()
        .then(({ data }) => {
          this.redbookDataMapper = data;
          this.$store.dispatch(SET_INFO, {
            ...this.info,
            redbookDataMapper: data,
          });
        });
    },
    // checkCarDescription() {
    //   if (this.$v.info.description.$dirty === false) {
    //     this.$v.info.description.$touch();
    //     this.isShowErr = true;
    //   }
    // }
    trimColorOnBlur() {
      const trimmedValue = this.info.specifyColor.trim();
      this.info.specifyColor = trimmedValue;
      
      // Force update if needed
      this.$nextTick(() => {
        if (this.$refs.specifyColorInput) {
          this.$refs.specifyColorInput.$el.value = trimmedValue;
        }
      });
    },
  },
  validations: {
    info: {
      make: {
        required,
      },
      model: {
        required,
      },
      year: {
        required,
      },
      color: {
        required,
      },
      location: {
        required,
      },
      kms: {
        required,
      },
      ownerManual: {
        required,
      },
      serviceHistory: {
        required,
      },
      serviceHistoryDetail: {
        required: function() {
          return this.info.serviceHistory === 'None' || this.info.serviceHistoryDetail !== ''
        },
      },
      drive: {
        required: function () {
          return this.drives.length <= 1 || this.info.drive !== "";
        },
      },
      transmission: {
        required: function () {
          return (
            this.transmissions.length <= 1 || this.info.transmission !== ""
          );
        },
      },
      exterior: {
        required,
      },
      interior: {
        required,
      },
      key: {
        required,
      },
      badgeEdition: {
        required: function () {
          return (
            this.badgeEditions.length <= 1 || this.info.badgeEdition !== ""
          );
        },
      },
      fuelType: {
        required: function () {
          return this.fuelTypes.length <= 1 || this.info.fuelType !== "";
        },
      },
      series: {
        required: function () {
          return this.series.length <= 1 || this.info.series !== "";
        },
      },
      model_year: {
        required: function () {
          return this.modelYears.length <= 1 || this.info.model_year !== "";
        },
      },
      engineType: {
        required: function () {
          return this.engineTypes.length <= 1 || this.info.engineType !== "";
        },
      },
      bodyType: {
        required: function () {
          return this.bodyTypes.length <= 1 || this.info.bodyType !== "";
        },
      },
      description: {
        required,
      },
      outstandingFinance: {
        required,
      },
      majorAccident: {
        required,
      },
      hailOrFlooding: {
        required,
      },
      warningLights: {
        required,
      },
      specifyColor: {
        required: function() {
          return this.info.color === "OTHER" ? this.info.specifyColor.length > 0 : true;
        },
      },
    },
  },
  watch: {
    "info.make": function (val) {
      if (val) {
        this.$store.dispatch(FETCH_MODELS, {
          make: val,
        });
        this.curStepInput = 3;
        this.onChange = true;
      }
      if ((Object.keys(this.regoSearch.rego || {}).length > 0) && (this.regoSearch.rego.make !== val)) {
        this.$store.dispatch(CLEAR_RELEVANT_RBDESC);
      }
    },
    "info.model": function (val) {
      if (val) {
        if (val !== 'Other') {
          this.$store.dispatch(CLEAR_INFO_EXTEND);
          this.$store.dispatch(FETCH_YEARS, {
            make: this.info.make,
            model: val,
          });
          this.curStepInput = 4;
          this.onChange = true;
        } else {
          this.$store.dispatch(CLEAR_INFO_EXTEND);
          this.$store.dispatch(SET_OTHER_OPTIONS, {
            make: this.info.make,
            model: '',
          });
        }
      }
      if ((Object.keys(this.regoSearch.rego || {}).length > 0) && (this.regoSearch.rego.model !== val)) {
        this.$store.dispatch(CLEAR_RELEVANT_RBDESC);
      }
    },
    "info.color": function(val) {
      if (val) {
        this.curStepInput = 5;
        this.$store.dispatch(SET_COLOR, val);
      }
    },
    "info.year": function (val) {
      if (val && this.info.model !== 'Other') {
        this.$store.dispatch(CLEAR_INFO_EXTEND);
        this.$store.dispatch(FETCH_BADGES, {
          make: this.info.make,
          model: this.info.model,
          year: val,
        });
        this.curStepInput = 6;
      }
      if ((Object.keys(this.regoSearch.rego || {}).length > 0) && (this.regoSearch.rego.year !== val)) {
        this.$store.dispatch(CLEAR_RELEVANT_RBDESC);
      }
    },
    "info.badgeEdition": function (val) {
      const splittedVal = val.split("|");
      this.info.badge = splittedVal[0];
      this.info.edition = splittedVal[1] === "" ? 'N/A' : splittedVal[1];
      if (
        val &&
        val.split('|').some(value => !blankOptionList.includes(value)) &&
        this.info.model !== 'Other'
      ) {
        this.$store.dispatch(SET_PREV_LENGTH, {prevLengthName: 'prevLengthBadgeEdition', stateName: 'badgeEditions' });
        this.$store.dispatch(SET_PREV_LENGTH, {prevLengthName: 'prevLengthBody', stateName: 'bodyTypes' }); 
        this.$store.dispatch(SET_PREV_LENGTH, {prevLengthName: 'prevLengthFuel', stateName: 'fuelTypes' });
        this.$store.dispatch(SET_PREV_LENGTH, {prevLengthName: 'prevLengthDrive', stateName: 'drives' });
        this.$store.dispatch(SET_PREV_LENGTH, {prevLengthName: 'prevLengthTrans', stateName: 'transmissions' });
        this.$store.dispatch(SET_PREV_LENGTH, {prevLengthName: 'prevLengthSeries', stateName: 'series' });
        this.$store.dispatch(SET_PREV_LENGTH, {prevLengthName: 'prevLengthEngine', stateName: 'engineTypes' });
        this.$store.dispatch(
          FETCH_DETAIL,
          this.fetchDetailRequestValues("badge", splittedVal[0])
        );
      }
      this.curStepInput = 7;
    },
    "info.bodyType": function (val) {
      if (val && this.info.model !== 'Other') {
        this.$store.dispatch(SET_PREV_LENGTH, {prevLengthName: 'prevLengthBody', stateName: 'bodyTypes' });
        this.$store.dispatch(
          FETCH_DETAIL,
          this.fetchDetailRequestValues("bodyType", val)
        );
        this.curStepInput = 8;
      }
    },
    "info.fuelType": function (val) {
      if (val && this.info.model !== 'Other') {
        this.$store.dispatch(SET_PREV_LENGTH, {prevLengthName: 'prevLengthFuel', stateName: 'fuelTypes' });
        this.$store.dispatch(
          FETCH_DETAIL,
          this.fetchDetailRequestValues("fuelType", val)
        );
        this.curStepInput = 9;
      }
    },
    "info.drive": function (val) {
      if (val && this.info.model !== 'Other') {
        this.$store.dispatch(SET_PREV_LENGTH, {prevLengthName: 'prevLengthDrive', stateName: 'drives' });
        this.$store.dispatch(
          FETCH_DETAIL,
          this.fetchDetailRequestValues("drive", val)
        );
        this.curStepInput = 10;
      }
    },
    "info.transmission": function (val) {
      if (val && this.info.model !== 'Other') {
        this.$store.dispatch(SET_PREV_LENGTH, {prevLengthName: 'prevLengthTrans', stateName: 'transmissions' });
        this.$store.dispatch(
          FETCH_DETAIL,
          this.fetchDetailRequestValues("transmission", val)
        );
        this.curStepInput = 11;
      }
    },
    "info.series": function (val) {
      if (
        val &&
        val.split('|').some(value => !blankOptionList.includes(value)) &&
        this.info.model !== 'Other'
      ) {
        this.$store.dispatch(SET_PREV_LENGTH, {prevLengthName: 'prevLengthSeries', stateName: 'series' });
        this.$store.dispatch(
          FETCH_DETAIL,
          this.fetchDetailRequestValues("series", val)
        );
      }
      this.curStepInput = 12;
    },
    "info.model_year": function() {
      this.curStepInput = 13;
    },
    "info.engineType": function (val) {
      if (val && val !== "Not sure" && this.info.model !== 'Other') {
        this.$store.dispatch(SET_PREV_LENGTH, {prevLengthName: 'prevLengthEngine', stateName: 'engineTypes' });
        this.$store.dispatch(
          FETCH_DETAIL,
          this.fetchDetailRequestValues("engineType", val)
        );
      }
      this.curStepInput = 14;
    },
    "info.kms": function() {
      this.$nextTick(
        () => (this.info.kms = formatNumberWithComma(this.info.kms))
      );
      this.curStepInput = 15;
    },
    "info.key": function() {
      this.curStepInput = 16;
    },
    "info.ownerManual": function() {
      this.curStepInput = 17;
    },
    "info.serviceHistory": function(val) {
      if (val === 'None') {
        this.$store.dispatch(CLEAR_SERVICE_HISTORY_DETAIL);
      }
    },
    "info.exterior": function() {
      // this.checkCarDescription();
      this.curStepInput = 19;
    },
    "info.interior": function() {
      // this.checkCarDescription();
      this.curStepInput = 20;
    },
    curStepInput: function () {
      let progress = 0;
      for (const item of this.inputStep) {
        const emptyApproved = item.key === 'series' || item.key === 'badgeEdition';
        if ((this.info[item.key] || emptyApproved) && item.key !== "") {
          progress = progress + (10 / (this.inputStep.length - 1));
        }
      }
      // this.$store.dispatch("setProgress", Math.floor(progress) * 10);
    },
  },
  created: function () {
    this.getData();
    this.getRedbookDataMapper();
  },
  mounted() {
    this.mobileMediaQuery.addListener((e) => {
      if (e.matches) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    });

    this.isMobile = !this.mobileMediaQuery.matches;

    this.$nextTick(
      () => (this.info.kms = formatNumberWithComma(this.info.kms))
    );
  },
};
</script>

<style lang="scss">
.form-stars {
  .b-rating-star {
    padding: 0 10px !important;
    z-index: 9;
  }
  .b-rating-icon {
    font-size: 40px !important;
  }
}

.content {
  margin: 0 auto;
  text-align: left;
  min-height: calc(100vh - 179px);
  overflow: auto;
  .card {
    border: none;
  }
}

.auto-info {
  background-color: #f2f2f2;
  border-color: #b3b3b3;
  margin-left: 10px;
  margin-right: 0;
}
.next-input {
  color: #383c3f;
  background-color: #fff;
  border-color: #00bb65;
  outline: 0;
}
.rate-label {
  color: #2BB673;
  text-align: center;
  text-transform: uppercase;
}
.bi-star-error {
  svg {
    path {
      fill: red;
    }
  }
}
.vehicle-condition-item {
  // padding-top: 25px;

  .star-rating {
    height: fit-content;
    padding: 0;
    margin-top: 6px;
    width: 70%;

    &:focus {
      box-shadow: none;
    }

    span.b-rating-star {
      padding: 0 4px;

      &:first-child {
        padding-left: 0;
      }

      svg {
        path {
          fill: #2bb673;
        }
        width: 35px;
        height: 35px;
      }
    }

    .b-rating-star-full {
      color: #00c44b;
    }
  }
}
#modal-exterior,
#modal-interior {
  .modal {
    padding-left: unset !important;
  }
  .modal-header {
    border-bottom: 0;
    padding: 1.6rem 1rem 0;
    .close {
      color: #2bb673;
      opacity: 1;
      &:hover {
        opacity: 0.5;
      }
    }
  }
  .modal-title {
    font-weight: bold;
  }
  .modal-body {
    padding-top: 0 !important;
  }
  .modal-content {
    border-radius: 1rem;
    border: 4px solid #2bb673;
  }
  hr {
    background-color: #c4c4c4 !important;
  }
}

.specify-color {
  position: relative;
}

.specify-color::before {
  content: '';
  top: -15px;
  left: -35px;
  position: absolute;
  width: 42.89px;
  height: 41.21px;
  border-left: 2px solid #CED4DA;
  border-bottom: 2px solid #CED4DA;
  border-bottom-left-radius: 6px;
}

@media screen and(min-width: 768px) {
  .card {
    padding: 0 48px !important;
    overflow-x: hidden;
  }

  .top-description {
    margin-left: 70px !important;
  }

  .condition-title {
    font-size: 0.9rem !important;
  }

  .content {
    overflow-x: hidden;
  }

  .form-stars,
  .rate-label-wrapper {
    justify-content: unset !important;
    margin-left: 1.5rem !important;
  }

  .modal-interior {
    max-width: 1080px;
  }

  .star-rating {
    width: 100%;
  }

  #modal-exterior,
  #modal-interior {
    .modal-title {
      width: 100% !important;
      text-align: center !important;
      padding-left: 56px !important;
      font-size: 24px;
    }
  }
}

// Tablet
@media screen and (min-width: 768px ) and (orientation: portrait) {
  #modal-exterior,
  #modal-interior {
    .modal-dialog {
      top: -10% !important;
    }
    .modal-dialog {
      max-width: 777px;
    }
  }
}

@media screen and(min-width: 356px) {
  .top-description {
    margin-left: 22px;
  }
}

@media screen and(min-width: 1200px) {
  .custom-width {
    flex: 0 0 56.3333333333%;
    max-width: 56.3333333333%;
  }
  .specify-color {
    flex: 0 0 43.6666666667%;
    max-width: 43.6666666667%;
  }
}
@media screen and(min-width: 990px) and(max-width: 1200px) {
  .custom-width {
    flex: 0 0 58.3333333333%;
    max-width: 58.3333333333%;
  }
  .specify-color {
    flex: 0 0 41.6666666667%;
    max-width: 41.6666666667%;
  }
}
@media screen and(min-width: 768px) and(max-width: 990px) {
  .custom-width {
    flex: 0 0 60.3333333333%;
    max-width: 60.3333333333%;
  }
  .specify-color {
    flex: 0 0 39.6666666667%;
    max-width: 39.6666666667%;
  }
}
</style>

